import { render, staticRenderFns } from "./EchartsXBar.vue?vue&type=template&id=078e0d64&scoped=true"
import script from "./EchartsXBar.vue?vue&type=script&lang=js"
export * from "./EchartsXBar.vue?vue&type=script&lang=js"
import style0 from "./EchartsXBar.vue?vue&type=style&index=0&id=078e0d64&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078e0d64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('078e0d64')) {
      api.createRecord('078e0d64', component.options)
    } else {
      api.reload('078e0d64', component.options)
    }
    module.hot.accept("./EchartsXBar.vue?vue&type=template&id=078e0d64&scoped=true", function () {
      api.rerender('078e0d64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/confirmation/Components/EchartsXBar.vue"
export default component.exports